import { apiCall } from './gqlClient';

const GETPROVIDERWORKOUTPLANS_QUERY = `
  query getProviderWorkoutPlans($userId: Int) {
    getProviderWorkoutPlans(userId: $userId)
    {
      id
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			dateCreated
			thumbnailUrl
			enrolled
			archive
			planGroupId
      ...fragments
    }
  }`;

export const getProviderWorkoutPlansApiCall = async ({userId}, fragments = null) => apiCall({ query: GETPROVIDERWORKOUTPLANS_QUERY, variables: {userId}, fragments });

const GETPROVIDERARCHIVEDWORKOUTPLANS_QUERY = `
  query getProviderArchivedWorkoutPlans {
    getProviderArchivedWorkoutPlans
    {
      id
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			dateCreated
			thumbnailUrl
			enrolled
			archive
			planGroupId
      ...fragments
    }
  }`;

export const getProviderArchivedWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERARCHIVEDWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETFREEWORKOUTPLANS_QUERY = `
  query getFreeWorkoutPlans {
    getFreeWorkoutPlans
    {
      id
			providerId
			userId
			groupId
			title
			description
			price
			public
			numberOfWeeks
			currentPlanNumberOfWeeks
			imageId
			active
			startTime
			endTime
			dateCreated
			personalPlan
			thumbnailUrl
			enrolled
			archive
      ...fragments
    }
  }`;

export const getFreeWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: GETFREEWORKOUTPLANS_QUERY, variables: {}, fragments });

const GETWORKOUTPLANDETAILS_QUERY = `
  query getWorkoutPlanDetails($id: String!) {
    getWorkoutPlanDetails(id: $id)
    {
      id
			providerId
			title
			description
			price
			public
			numberOfWeeks
			imageId
			active
			dateCreated
			thumbnailUrl
			enrolled
			archive
			planGroupId
      ...fragments
    }
  }`;

export const getWorkoutPlanDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETWORKOUTPLANDETAILS_QUERY, variables: {id}, fragments });

const CREATEWORKOUTPLAN_QUERY = `
  mutation createWorkoutPlan($request: WorkoutPlanInput!) {
    createWorkoutPlan(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createWorkoutPlanApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEWORKOUTPLAN_QUERY, variables: {request}, fragments });

const DUPLICATEWORKOUTPLAN_QUERY = `
  mutation duplicateWorkoutPlan($id: String!) {
    duplicateWorkoutPlan(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const duplicateWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATEWORKOUTPLAN_QUERY, variables: {id}, fragments });

const UPDATEWORKOUTPLAN_QUERY = `
  mutation updateWorkoutPlan($request: WorkoutPlanUpdateInput!) {
    updateWorkoutPlan(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateWorkoutPlanApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEWORKOUTPLAN_QUERY, variables: {request}, fragments });

const ADDWORKOUTTOPLAN_QUERY = `
  mutation addWorkoutToPlan($workoutPlanId: String!, $workouts: [WorkoutPlanScheduleInput]!) {
    addWorkoutToPlan(workoutPlanId: $workoutPlanId, workouts: $workouts)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const addWorkoutToPlanApiCall = async ({workoutPlanId, workouts}, fragments = null) => apiCall({ query: ADDWORKOUTTOPLAN_QUERY, variables: {workoutPlanId, workouts}, fragments });

const EDITWORKOUTINPLAN_QUERY = `
  mutation editWorkoutInPlan($planId: String!, $workouts: [WorkoutPlanScheduleInput]!) {
    editWorkoutInPlan(planId: $planId, workouts: $workouts)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const editWorkoutInPlanApiCall = async ({planId, workouts}, fragments = null) => apiCall({ query: EDITWORKOUTINPLAN_QUERY, variables: {planId, workouts}, fragments });

const DELETEWORKOUTINPLAN_QUERY = `
  mutation deleteWorkoutInPlan($id: String!) {
    deleteWorkoutInPlan(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteWorkoutInPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTINPLAN_QUERY, variables: {id}, fragments });

const RESTOREWORKOUTPLAN_QUERY = `
  mutation restoreWorkoutPlan($id: String!) {
    restoreWorkoutPlan(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const restoreWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: RESTOREWORKOUTPLAN_QUERY, variables: {id}, fragments });

const CHANGEWORKOUTPLANSTATUS_QUERY = `
  mutation changeWorkoutPlanStatus($id: String!, $active: Boolean!) {
    changeWorkoutPlanStatus(id: $id, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeWorkoutPlanStatusApiCall = async ({id, active}, fragments = null) => apiCall({ query: CHANGEWORKOUTPLANSTATUS_QUERY, variables: {id, active}, fragments });
